const namespace = 'pages/home/';
export const SET_API_ERROR = `${namespace}SET_API_ERROR`;
export const CLIENT_BANNER_REQUEST = `${namespace}CLIENT_BANNER_REQUEST`;
export const GET_BUY_AGAIN_REQUEST = `${namespace}GET_BUY_AGAIN_REQUEST`;
export const GET_BUY_AGAIN_ALL_REQUEST = `${namespace}GET_BUY_AGAIN_ALL_REQUEST`;
export const GET_BUYER_DETAILS_REQUEST = `${namespace}GET_BUYER_DETAILS_REQUEST`;
export const GET_PRODUCT_COLLECTION_LIST_REQUEST = `${namespace}GET_PRODUCT_COLLECTION_LIST_REQUEST`;
export const UPDATE_NOTIFICATION_BAR = `${namespace}UPDATE_NOTIFICATION_BAR`;

export const IN_STOCK_DELIVERY_COUNT = '9';
